/**
 * Generated by scripts/generate-drizzle-schema.mjs. Do not edit by hand.
 * This product's inputs: scripts/drizzle-schema.config.mjs.
 * Regenerate: bash scripts/client-schema-fresh.sh (data-model-change skill).
 */

import { DrizzleAppSchema, type PowerSyncSQLiteDatabase } from "@powersync/drizzle-driver";
import { index, integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";
import type { InferInsertModel, InferSelectModel } from "drizzle-orm";

export const attachment = sqliteTable(
  "attachment",
  {
    id: text("id").primaryKey(),
    filename: text("filename"),
    content_type: text("content_type"),
    size: integer("size"),
    url: text("url"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    user_id: text("user_id"),
    is_shared: integer("is_shared"),
    hash: text("hash"),
  },
  (table) => [
    /** WHERE user_id = ? in getHasLocalDataQuery */
    index("attachment_by_user").on(table.user_id),
  ],
);

export const body_measurement = sqliteTable(
  "body_measurement",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    measured_at: text("measured_at"),
    weight_kg: real("weight_kg"),
    body_fat_pct: real("body_fat_pct"),
    waist_cm: real("waist_cm"),
    chest_cm: real("chest_cm"),
    biceps_cm: real("biceps_cm"),
    thigh_cm: real("thigh_cm"),
    hips_cm: real("hips_cm"),
    note: text("note"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** ORDER BY measured_at DESC in getBodyMeasurementsQuery */
    index("body_measurement_by_date").on(table.measured_at),
  ],
);

// Global catalog (~100 rows) + custom exercises — small dataset, no indexes.
export const exercise = sqliteTable("exercise", {
  id: text("id").primaryKey(),
  user_id: text("user_id"),
  name_en: text("name_en"),
  name_es: text("name_es"),
  muscle_group: text("muscle_group"),
  equipment: text("equipment"),
  default_rest_seconds: integer("default_rest_seconds"),
  is_archived: integer("is_archived"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  deleted_at: text("deleted_at"),
});

export const font_family = sqliteTable("font_family", {
  id: text("id").primaryKey(),
  family: text("family"),
  name: text("name"),
  category: text("category"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
});

export const font_variant = sqliteTable("font_variant", {
  id: text("id").primaryKey(),
  font_family_id: text("font_family_id"),
  weight: text("weight"),
  url: text("url"),
  created_at: text("created_at"),
  attachment_id: text("attachment_id"),
});

// Small dataset per user — indexes not needed currently.
export const member = sqliteTable("member", {
  id: text("id").primaryKey(),
  organization_id: text("organization_id"),
  user_id: text("user_id"),
  role: text("role"),
  created_at: text("created_at"),
});

// Small dataset — indexes not needed currently.
export const organization = sqliteTable("organization", {
  id: text("id").primaryKey(),
  name: text("name"),
  slug: text("slug"),
  logo: text("logo"),
  metadata: text("metadata"),
  created_at: text("created_at"),
});

export const routine = sqliteTable(
  "routine",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    name: text("name"),
    description: text("description"),
    position: integer("position"),
    is_archived: integer("is_archived"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    deleted_at: text("deleted_at"),
    current_version_id: text("current_version_id"),
    version_number: integer("version_number"),
  },
  (table) => [
    /** WHERE user_id = ? ORDER BY position in getRoutinesQuery */
    index("routine_by_user").on(table.user_id, table.position),
  ],
);

export const routine_exercise = sqliteTable(
  "routine_exercise",
  {
    id: text("id").primaryKey(),
    routine_id: text("routine_id"),
    exercise_id: text("exercise_id"),
    user_id: text("user_id"),
    position: integer("position"),
    target_sets: integer("target_sets"),
    target_reps_min: integer("target_reps_min"),
    target_reps_max: integer("target_reps_max"),
    rest_seconds: integer("rest_seconds"),
    note: text("note"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE routine_id = ? ORDER BY position in getRoutineExercisesQuery */
    index("routine_exercise_by_routine").on(table.routine_id, table.position),
  ],
);

export const routine_version = sqliteTable(
  "routine_version",
  {
    id: text("id").primaryKey(),
    routine_id: text("routine_id"),
    user_id: text("user_id"),
    version_number: integer("version_number"),
    name: text("name"),
    description: text("description"),
    items: text("items"),
    text: text("text"),
    client_ts: text("client_ts"),
    server_ts: text("server_ts"),
  },
  (table) => [
    /** WHERE routine_id = ? ORDER BY id DESC in getRoutineVersionsQuery */
    index("routine_version_by_routine").on(table.routine_id, table.id),
  ],
);

// Active user sessions — small dataset, no indexes.
export const session = sqliteTable("session", {
  id: text("id").primaryKey(),
});

// Small global dataset (~20 themes) — indexes not needed.
export const themes = sqliteTable("themes", {
  id: text("id").primaryKey(),
  name: text("name"),
  background: text("background"),
  surface: text("surface"),
  accent: text("accent"),
  glow_colors: text("glow_colors"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  is_dark: integer("is_dark"),
  foreground: text("foreground"),
  field_background: text("field_background"),
  danger: text("danger"),
  success: text("success"),
  warning: text("warning"),
  muted: text("muted"),
  pattern_type: text("pattern_type"),
  pattern_opacity: integer("pattern_opacity"),
  pair_id: text("pair_id"),
  font_normal: text("font_normal"),
  font_medium: text("font_medium"),
  font_semibold: text("font_semibold"),
  font_bold: text("font_bold"),
  radius: text("radius"),
  surface_foreground: text("surface_foreground"),
  surface_secondary: text("surface_secondary"),
  surface_secondary_foreground: text("surface_secondary_foreground"),
  surface_tertiary: text("surface_tertiary"),
  surface_tertiary_foreground: text("surface_tertiary_foreground"),
  overlay: text("overlay"),
  overlay_foreground: text("overlay_foreground"),
  default: text("default"),
  default_foreground: text("default_foreground"),
  accent_foreground: text("accent_foreground"),
  field_foreground: text("field_foreground"),
  field_placeholder: text("field_placeholder"),
  field_border: text("field_border"),
  danger_foreground: text("danger_foreground"),
  success_foreground: text("success_foreground"),
  warning_foreground: text("warning_foreground"),
  segment: text("segment"),
  segment_foreground: text("segment_foreground"),
  border: text("border"),
  focus: text("focus"),
  link: text("link"),
  surface_shadow: text("surface_shadow"),
  overlay_shadow: text("overlay_shadow"),
  field_shadow: text("field_shadow"),
  muted_foreground: text("muted_foreground"),
  divider: text("divider"),
  glass_background: text("glass_background"),
  glass_border: text("glass_border"),
  glass_highlight: text("glass_highlight"),
  is_active: integer("is_active"),
  sort_order: integer("sort_order"),
});

// Single row per user — indexes not needed.
export const user = sqliteTable("user", {
  id: text("id").primaryKey(),
  name: text("name"),
  email: text("email"),
  email_verified: integer("email_verified"),
  image: text("image"),
  created_at: text("created_at"),
  updated_at: text("updated_at"),
  locale: text("locale"),
  global_theme_id: text("global_theme_id"),
  is_blur: integer("is_blur"),
  font_family: text("font_family"),
  follow_device_theme: integer("follow_device_theme"),
  role: text("role"),
});

export const workout_session = sqliteTable(
  "workout_session",
  {
    id: text("id").primaryKey(),
    user_id: text("user_id"),
    routine_id: text("routine_id"),
    name: text("name"),
    started_at: text("started_at"),
    finished_at: text("finished_at"),
    note: text("note"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
    routine_version_id: text("routine_version_id"),
  },
  (table) => [
    /** WHERE user_id = ? ORDER BY started_at DESC in getSessionsQuery/getOpenSessionQuery */
    index("workout_session_by_user").on(table.user_id, table.started_at),
  ],
);

// Largest table in the gym domain (grows with every recorded set).
export const workout_set = sqliteTable(
  "workout_set",
  {
    id: text("id").primaryKey(),
    session_id: text("session_id"),
    exercise_id: text("exercise_id"),
    user_id: text("user_id"),
    set_number: integer("set_number"),
    weight_kg: real("weight_kg"),
    reps: integer("reps"),
    rpe: real("rpe"),
    is_warmup: integer("is_warmup"),
    completed_at: text("completed_at"),
    created_at: text("created_at"),
    updated_at: text("updated_at"),
  },
  (table) => [
    /** WHERE session_id = ? ORDER BY set_number in getSessionSetsQuery */
    index("workout_set_by_session").on(table.session_id, table.set_number),
    /** WHERE exercise_id = ? ORDER BY completed_at DESC in getLastSetQuery/getExerciseHistoryQuery/PRs */
    index("workout_set_by_exercise").on(table.exercise_id, table.completed_at),
  ],
);

export const drizzleSchema = {
  attachment,
  body_measurement,
  exercise,
  font_family,
  font_variant,
  member,
  organization,
  routine,
  routine_exercise,
  routine_version,
  session,
  themes,
  user,
  workout_session,
  workout_set,
};

export const AppSchema = new DrizzleAppSchema(drizzleSchema);

export type Database = (typeof AppSchema)["types"];

/**
 * Type helper for the Drizzle database instance wrapped with PowerSync.
 */
export type PowerSyncDrizzleDB = PowerSyncSQLiteDatabase<typeof drizzleSchema>;

export const USER_DATA_TABLES = [
  "attachment",
  "body_measurement",
  "exercise",
  "routine",
  "routine_exercise",
  "workout_session",
  "workout_set",
] as const;

export type Attachment = InferSelectModel<typeof attachment>;
export type AttachmentInsert = InferInsertModel<typeof attachment>;
export type AttachmentRecord = Attachment;
export type BodyMeasurement = InferSelectModel<typeof body_measurement>;
export type BodyMeasurementInsert = InferInsertModel<typeof body_measurement>;
export type BodyMeasurementRecord = BodyMeasurement;
export type Exercise = InferSelectModel<typeof exercise>;
export type ExerciseInsert = InferInsertModel<typeof exercise>;
export type ExerciseRecord = Exercise;
export type FontFamily = InferSelectModel<typeof font_family>;
export type FontFamilyInsert = InferInsertModel<typeof font_family>;
export type FontFamilyRecord = FontFamily;
export type FontVariant = InferSelectModel<typeof font_variant>;
export type FontVariantInsert = InferInsertModel<typeof font_variant>;
export type FontVariantRecord = FontVariant;
export type Member = InferSelectModel<typeof member>;
export type MemberInsert = InferInsertModel<typeof member>;
export type MemberRecord = Member;
export type Organization = InferSelectModel<typeof organization>;
export type OrganizationInsert = InferInsertModel<typeof organization>;
export type OrganizationRecord = Organization;
export type Routine = InferSelectModel<typeof routine>;
export type RoutineInsert = InferInsertModel<typeof routine>;
export type RoutineRecord = Routine;
export type RoutineExercise = InferSelectModel<typeof routine_exercise>;
export type RoutineExerciseInsert = InferInsertModel<typeof routine_exercise>;
export type RoutineExerciseRecord = RoutineExercise;
export type RoutineVersion = InferSelectModel<typeof routine_version>;
export type RoutineVersionInsert = InferInsertModel<typeof routine_version>;
export type RoutineVersionRecord = RoutineVersion;
export type Session = InferSelectModel<typeof session>;
export type SessionInsert = InferInsertModel<typeof session>;
export type SessionRecord = Session;
export type Themes = InferSelectModel<typeof themes>;
export type ThemesInsert = InferInsertModel<typeof themes>;
export type ThemesRecord = Themes;
export type User = InferSelectModel<typeof user>;
export type UserInsert = InferInsertModel<typeof user>;
export type UserRecord = User;
export type WorkoutSession = InferSelectModel<typeof workout_session>;
export type WorkoutSessionInsert = InferInsertModel<typeof workout_session>;
export type WorkoutSessionRecord = WorkoutSession;
export type WorkoutSet = InferSelectModel<typeof workout_set>;
export type WorkoutSetInsert = InferInsertModel<typeof workout_set>;
export type WorkoutSetRecord = WorkoutSet;
